import React from "react";
import ReactDOM from "react-dom/client";
import App from "App";

import { AuthContextProvider } from "contexts/AuthContext";
import { BrowserRouter as Router } from "react-router-dom";

// Se movió el Router aqui, para poder usar el useNavigate dentro del context. Esto es porque
//NO se puede usar usenagivate fuera del Router
ReactDOM.createRoot(document.getElementById("root")).render(
  <Router>
    <AuthContextProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </AuthContextProvider>
  </Router>
);
